
<Component :is="getComponent(item)" :item="item" />
